import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { AccountDeleted } from './TheNightlyAccountDeleted'

export const TheNightlyAccountDeletedRegistration = createRegisterableComponent(
    'thenightly-account-deleted',
    () => {
        return <AccountDeleted />
    },
)
